var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: [
        {
          active:
            _vm.selectedDivision === _vm.division.id ||
            (_vm.selectedDivisions ?? []).includes(_vm.division.id) ||
            _vm.division.selected,
        },
        "btn btn-outline-info",
      ],
      attrs: { disabled: _vm.loading, type: "button" },
      on: { click: () => _vm.selectDivision(_vm.division) },
    },
    [
      _c("p", { staticClass: "division_runner" }, [
        _vm._v(
          _vm._s(
            _vm.division?.user?.short_name ||
              _vm.division?.user?.name ||
              _vm.getUsersByDivision(_vm.division.id)
          )
        ),
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "d_info" },
        [
          _c("strong", [_vm._v(_vm._s(_vm.division.title))]),
          _vm._v(" "),
          _vm.orderStatuses
            ? [
                _c("span", { staticClass: "badge badge-info" }, [
                  _vm._v(_vm._s(_vm.orderStatuses.waiting ?? 0)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "badge badge-success" }, [
                  _vm._v(_vm._s(_vm.orderStatuses.appointed ?? 0)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v(_vm._s(_vm.orderStatuses.overdue ?? 0)),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "d_info_city" },
        _vm._l(_vm.division.cities, function (city, index) {
          return _c("span", [
            _vm._v(
              _vm._s(index > 0 ? ", " : "") +
                _vm._s(_vm.$AllCities[city.object_id]?.name)
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }